/*
Poornima 09/19/2022 2700799562 Fixed GAL-127,132,73,60,104 bugs
Aditya 09/26/2022 2700799562 Implemented Save alert
Ashraf 09/29/2022 2700799562 fixed bugs on global fields
Aditya 09/29/2022 2700799562 Implemented save alert for Global Fields module
Poornima 09/29/2022 2700799562 Tab names changed
Sohel 09/30/2022 2700799562 Global Field List ->Added Copy Functionality(GAL-311) and Table Payload Changes.
Ashraf 10/04/2022 2700799562 fixed copy, page break issue
Ashraf 10/14/2022 270079956 Global Field ->Added Code Comments.
Ashraf 10/14/2022 270079956 Global Field ->Added Code Comments Changes
Ashraf 10/17/2022 270079956 Design Enhancements in global Field Group, List.
Ashraf 10/18/2022 270079956 field list UI changes
Ashraf 01/11/2022 270079956 conditional renders for audit list

*/
import React, {useEffect, useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AppContext from '../../../../components/contextProvider/AppContextProvider/AppContext';
import AddFieldList from './AddFieldList';
import SearchFieldList from './SearchFieldList';
import UsageFieldList from './UsageFielsList';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import SaveAlert from '../../../../components/DialogBox/SaveAlert';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchButtons': {
    margin: '-8px 0 8px',
  },

  'popup': {
    background: 'black',
  },
}));

export default function SubTabsContent({setTableValue, StepperFieldList, AuditFieldList}) {
  const classes = useStyles();
  const [tabvalue, setTabValue] = useState(0);
  const [fieldListRowData, setFieldListRowData] = useState('');
  const [usageState, setUsageState] = useState(false);
  const {reportMasterId} = useContext(AppContext);
  const [isCopyData, setIsCopyData] = useState(false);
  const {setGlobalFieldRow, sample, setNewTabValue} =
    useContext(SelectTabContextProvider);
  const [rowSelected, setRowSelected] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (reportMasterId !== '') {
      setTabValue(1);
    }
  }, [reportMasterId]);

  // component render set Copy is false(2700799562)
  useEffect(() => {
    setIsCopyData(false);
  }, []);

  // set Tab value(2700799562)
  const handleChange = (event, newValue) => {
    if (tabvalue === 1 && sample && newValue === 0) {
      setOpen(true);
      setNewTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
    setGlobalFieldRow(false);
  };
  return (
    // Removed sub tabs (2700799562)
    <div className={classes.root}>
      <div className={classes.searchButtons}>
        {open && (
          <SaveAlert setTabValue={setTabValue} setOpen={setOpen} open={open} tabvalue={tabvalue} />
        )}
        {/* <AntTabs
          className={classes.demo1}
          value={tabvalue}
          onChange={handleChange}
          aria-label="ant example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <AntTab label="Search Field List" />
          <AntTab label="Add / View Field List" />
          {tabvalue === 2 && <AntTab label="Usage Field List" />}
        </AntTabs> */}
        <Typography />
      </div>
      <div className={classes.subContent}>
        {tabvalue === 0 ? (
          <SearchFieldList
            setFieldListRowData={setFieldListRowData}
            setTabValue={setTabValue}
            usageState={usageState}
            setUsageState={setUsageState}
            setRowSelected={setRowSelected}
            setIsCopyData={setIsCopyData}
            StepperFieldList={StepperFieldList}
            AuditFieldList={AuditFieldList}
          />
        ) :
          tabvalue === 1 ? (
            <AddFieldList
              setTabValue={setTabValue}
              setUsageState={setUsageState}
              rowSelected={rowSelected}
              isCopyData={isCopyData}
              handleChange={handleChange}
              AuditFieldList={AuditFieldList}
            />
          ) :
            tabvalue === 2 ? (
              <UsageFieldList
                fieldListRowData={fieldListRowData}
                setTabValue={setTabValue}
                setUsageState={setUsageState}
                rowSelected={rowSelected}
                AuditFieldList={AuditFieldList}
              />
            ) : null}
      </div>
    </div>
  );
}
